import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
} from "../../../assets/images/index";

const SpecialOffers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="what we repair" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1101"
          img={spfOne}
          productName="fridges"
          price=""
          color="repare"
          badge={true}
          des="."
        />
        <Product
          _id="1102"
          img={spfTwo}
          productName="microwave"
          price=""
          color="repair"
          badge={true}
          des="Available."
        />
        <Product
          _id="1103"
          img={spfThree}
          productName="cooker"
          price=""
          color="repair"
          badge={true}
          des="Available."
        />
        <Product
          _id="1104"
          img={spfFour}
          productName="air condition"
          price=""
          color="repair"
          badge={true}
          des="available."
        />
      </div>
    </div>
  );
};

export default SpecialOffers;
